import { gql } from '@apollo/client';

/**
 * 按地址查同址揽收站点（揽收站点 2.0 · AB 映射搜索，只查不建）。
 *
 * 与建站/命中**同一套 core_hash 口径**（后端 `findCooperationWarehousesByAddress` 内部走
 * 地址库标准化 → relate/cw 按 hash 命中 → 同 hub + status∈{1,2} 过滤），所以查得到就一定是
 * 系统认为的"同一个地址"。
 *
 * 不要换成「站点管理」那套地址 LIKE 模糊筛选：那是给运营手打关键字用的，命中口径与落库不一致。
 * 本入口的地址已经过 standardizePickupAddress 标准化，可以走精确 hash。
 */
export const FIND_COOPERATION_WAREHOUSES_BY_ADDRESS = gql`
  query FindCooperationWarehousesByAddress(
    $warehouseId: Long!
    $addressLine1: String!
    $city: String!
    $state: String!
    $zipcode: String!
    $addressLine2: String
  ) {
    findCooperationWarehousesByAddress(
      warehouseId: $warehouseId
      addressLine1: $addressLine1
      city: $city
      state: $state
      zipcode: $zipcode
      addressLine2: $addressLine2
    ) {
      id
      name
      addressLine1
      city
      state
      zipcode
      linkStatus
    }
  }
`;

export interface SameAddressSite {
  /** CooperationWarehouseType.id 在 schema 上可空，用前须判空 */
  id: number | null;
  name: string | null;
  addressLine1: string | null;
  city: string | null;
  state: string | null;
  zipcode: string | null;
  linkStatus: number | null;
}

export interface FindCooperationWarehousesByAddressResponse {
  findCooperationWarehousesByAddress: SameAddressSite[];
}

export interface FindCooperationWarehousesByAddressVariables {
  warehouseId: number;
  addressLine1: string;
  city: string;
  state: string;
  zipcode: string;
  addressLine2?: string;
}
